import $ from "jquery";
import {GPProjectView} from "./gp-projectview.js";
import { writable } from 'svelte/store';
import {mode} from "./gp.js";

export const brushModeStore = writable('optionBrush');
export const brushSizeStore = writable('optionBrush2');
export const brushShapeStore = writable('optionSquare');
export const activeTextureStore = writable(null);
export const rotationStore = writable(0);
export const zoomStore = writable(1);
export const hsvHStore = writable(0);
export const hsvSStore = writable(0);
export const hsvVStore = writable(0);

export let GPContextTexture = {
    textureLayer: null, //This is KonvaLayer from GPProjectView, part of the final view. On this we also display cursor.
    textureCanvas: null, // Source image for pattern
    currentTexture: null, // Texture definition from GP.texturesById
    currentRotation: 0,
    currentZoom: 1,
    currentH: 0,
    currentS: 0,
    currentV: 0,
    /**
     * @type {"optionBrush"|"optionEraser"}
     */
    brushMode: "optionBrush",
    /**
     * @type {"optionBrush1"|"optionBrush2"|"optionBrush3"}
     */
    brushSize: "optionBrush2",
    /**
     * @type {"optionCircle"|"optionSquare"}
     */
    brushShape: "optionSquare",
    brushSizes: {'optionBrush1': 15, 'optionBrush2': 30, 'optionBrush3': 50},
    xbrushSizes: {'optionBrush1': 100, 'optionBrush2': 200, 'optionBrush3': 300},
    brushSquareRatio: 5,
    brushSquareRounding: 1,
    textureCursorCircle: null,
    textureCursorSquare: null,
    textureCursorLastPos: null,
    textureContext: null, //js 2d drawing context

    storesInitiated: false,

    init: function (textureLayer) {
        activeTextureStore.set(GP.textures[0]);
        GPContextTexture.textureLayer = textureLayer;

        GPContextTexture.textureCursorCircle = new Konva.Circle({
            x: 100,
            y: 100,
            radius: 70,
            stroke: 'white',
            dash: [4, 4],
            strokeWidth: 1
        }).visible(false);
        GPContextTexture.textureCursorSquare = new Konva.Rect({
            x: 100,
            y: 100,
            width: 100,
            height: 20,
            stroke: 'white',
            dash: [4, 4],
            strokeWidth: 1
        }).visible(false);
        GPContextTexture.textureLayer.add(GPContextTexture.textureCursorCircle);
        GPContextTexture.textureLayer.add(GPContextTexture.textureCursorSquare);

        GPContextTexture.textureLayer.on("mouseenter", GPContextTexture.activateCursor);
        GPContextTexture.textureLayer.on("mouseleave", GPContextTexture.disableTextureCursor);
        GPContextTexture.textureLayer.on('mousemove', GPContextTexture.moveTextureCursorHandler);
        GPContextTexture.textureLayer.listening(false);

        if (!GPContextTexture.storesInitiated) {
            brushShapeStore.subscribe((s) => {
                GPContextTexture.brushShape = s;
                GPContextTexture.updateTextureCursorMode()
            });
            brushSizeStore.subscribe((s) => {
                GPContextTexture.brushSize = s;
                GPContextTexture.updateTextureCursorMode()
            });
            brushModeStore.subscribe((s) => {
                GPContextTexture.brushMode = s;
                GPContextTexture.updateTextureCursorMode()
            });
            activeTextureStore.subscribe((s) => {
                rotationStore.set(0);
                GPContextTexture.currentRotation = 0;
                zoomStore.set(1);
                GPContextTexture.currentZoom = 1;
                hsvHStore.set(0);
                GPContextTexture.currentH = 0;
                hsvSStore.set(0);
                GPContextTexture.currentS = 0;
                hsvVStore.set(0);
                GPContextTexture.currentV = 0;
                brushModeStore.set("optionBrush");
                if (!GPContextTexture.currentTexture || GPContextTexture.currentTexture !== s) {
                    GPContextTexture.currentTexture = s;
                    GPContextTexture.setTexture()
                }
            });
            rotationStore.subscribe((s) => {
                if (GPContextTexture.currentRotation !== s) {
                    GPContextTexture.currentRotation = s;
                    GPContextTexture.setTexture();
                }
            });
            zoomStore.subscribe((s) => {
                if (GPContextTexture.currentZoom !== s) {
                    GPContextTexture.currentZoom = s;
                    GPContextTexture.setTexture();
                }
            });
            hsvHStore.subscribe((s) => {
                if (GPContextTexture.currentH !== s) {
                    GPContextTexture.currentH = s;
                    GPContextTexture.setTexture();
                }
            });
            hsvSStore.subscribe((s) => {
                if (GPContextTexture.currentS !== s) {
                    GPContextTexture.currentS = s;
                    GPContextTexture.setTexture();
                }
            });
            hsvVStore.subscribe((s) => {
                if (GPContextTexture.currentV !== s) {
                    GPContextTexture.currentV = s;
                    GPContextTexture.setTexture();
                }
            });

            mode.subscribe((m) => {
                if (m === "Textures")
                    GPContextTexture.activate();
                else
                    GPContextTexture.deactivate();

                if (m === "Plants" || m === "Structures" || m === "Snippets" || m === "Custom" || m === "Textures")
                    GPContextTexture.textureLayer.visible(true);
                if (m === "Cloner" || m === "Inpainting" || m === "FixedCutter")
                    GPContextTexture.textureLayer.visible(false);

            })

            GPContextTexture.storesInitiated = true;
        }

        $(document).off("GPBackgroundLoaded", GPContextTexture.setTexture).on("GPBackgroundLoaded", GPContextTexture.setTexture);
    },

    onresize: function () {
        GPContextTexture.updateTextureCursorMode()
    },

    activate: function (id) {
        $(document).off("keydown", GPContextTexture.handleKeyboard).on("keydown", GPContextTexture.handleKeyboard);
        GPContextTexture.setupTextureCursor();
        GPContextTexture.textureLayer.listening(true);
        GPContextTexture.resetTexture();
    },

    deactivate: function () {
        $(document).off("keydown", GPContextTexture.handleKeyboard);
        GPContextTexture.textureLayer.listening(false);
        GPContextTexture.disableTextureCursor();
    },

    textureQueue: [],
    processingQueue: false,
    processQueue: async function () {
        if (GPContextTexture.processingQueue || GPContextTexture.textureQueue.length === 0) {
            return;
        }

        GPContextTexture.processingQueue = true;
        const { resolve, reject, rotation, zoom } = GPContextTexture.textureQueue.shift();

        try {
            const cnv = await GPContextTexture.currentTexture.getTextureCanvas(rotation, zoom);
            GPContextTexture.textureCanvas = cnv;
            GPContextTexture.resetTexture();
            resolve();
        } catch (error) {
            reject(error);
        } finally {
            GPContextTexture.processingQueue = false;
            GPContextTexture.processQueue();
        }
    },

    setTexture: function () {
        GP.showWaiting();

        const textureRequest = {
            rotation: GPContextTexture.currentRotation,
            zoom: GPContextTexture.currentZoom
        };

        const promise = new Promise((resolve, reject) => {
            Object.assign(textureRequest, { resolve, reject });
        });

        GPContextTexture.textureQueue = [textureRequest]; // Replace the queue with the new request
        GPContextTexture.processQueue();

        promise
            .catch((error) => {
                console.error('Error while setting texture:', error);
            })
            .finally(() => {
                GP.clearWaiting();
            });
    },

    setFilter: function() {
        let h = GPContextTexture.currentH;
        let s = 1+GPContextTexture.currentS / 3;
        let v = 1+GPContextTexture.currentV / 3;
        GPContextTexture.textureContext.filter = 'brightness('+v+') saturate('+s+') hue-rotate('+h+'deg)';
    },

    resetTexture: function () {
        var isPaint = false;

        // now we need to bind some events
        // we need to start drawing on mousedown
        // and stop drawing on mouseup
        GPContextTexture.textureLayer.off('touchstart mousedown').on('touchstart mousedown', function (event) {
            GP.saveUndo("surface", GP.project.textureCanvas.toDataURL('image/webp'));
            isPaint = true;
            GPContextTexture.textureCursorLastPos = GPProjectView.getPointerPosition(event);
        });

        GPContextTexture.textureLayer.off('touchend mouseup').on('touchend mouseup', function () {
            isPaint = false;
        });

        //if we're incidentaly leave drawing area and return later - start line at
        //the new entry point
        function updateCursorPos (event) {
            GPContextTexture.textureCursorLastPos = GPProjectView.getPointerPosition(event);
            if (event.evt.buttons !== 1) isPaint = false;
        }
        GPContextTexture.textureLayer.off('mouseenter', updateCursorPos).on('mouseenter', updateCursorPos );

        // and core function - drawing
        function doDraw(event) {
            if (!isPaint)
                return;

            var lastLocalPos = {
                x: GPContextTexture.textureCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextTexture.textureCursorLastPos.y / GPProjectView.sceneScale
            };

            var pos = GPProjectView.getPointerPosition(event);

            var localPos = {
                x: pos.x / GPProjectView.sceneScale,
                y: pos.y / GPProjectView.sceneScale
            };

            GPContextTexture.drawTexture(lastLocalPos, localPos);

            GPContextTexture.textureCursorLastPos = pos;
        }
        GPContextTexture.textureLayer.off('touchmove mousemove', doDraw).on('touchmove mousemove', doDraw);

        // Good. Now we need to get access to GPProjectView.textureContext element
        GPContextTexture.textureContext = GP.project.textureCanvas.getContext('2d');

        GPContextTexture.setFilter();

        GPContextTexture.textureContext.lineJoin = "round";
        GPContextTexture.textureContext.lineWidth = GPContextTexture.brushSizes[GPContextTexture.brushSize] * GP.project.sizeX / 1024;
        var pattern = GPContextTexture.textureContext.createPattern(GPContextTexture.textureCanvas, 'repeat');
        GPContextTexture.textureContext.strokeStyle = pattern;
        GPContextTexture.textureContext.fillStyle = pattern;

        GPContextTexture.updateTextureCursorMode();
    },

    drawTexture: function(from, to) {
        //Dont allow drawing above horizon
        if (to.y < (1-GP.project.horizonPos)*GP.project.sizeY) {
            GPProjectView.showHorizonHint();
            return;
        }

        if (GPContextTexture.brushMode === "optionBrush") {
            GPContextTexture.textureContext.globalCompositeOperation = 'source-over';
        }
        if (GPContextTexture.brushMode === "optionEraser") {
            GPContextTexture.textureContext.globalCompositeOperation = 'destination-out';
        }        

        if (GPContextTexture.brushShape === "optionSquare") {
            GPContextTexture.textureContext.beginPath();

            if (from.y > to.y) {
                [from.x, to.x] = [to.x, from.x];
                [from.y, to.y] = [to.y, from.y];
            }

            let fromXPenWidth = GPContextTexture.calcSquareCursorSize(from.y) / GPProjectView.sceneScale * GPProjectView.width / 1024;
            let toXPenWidth = GPContextTexture.calcSquareCursorSize(to.y) / GPProjectView.sceneScale * GPProjectView.width / 1024;

            let fromYPenWidth = fromXPenWidth / GPContextTexture.brushSquareRatio;
            let toYPenWidth = toXPenWidth / GPContextTexture.brushSquareRatio;
            GPContextTexture.textureContext.moveTo(from.x - fromXPenWidth, from.y - fromYPenWidth);
            GPContextTexture.textureContext.lineTo(from.x + fromXPenWidth, from.y - fromYPenWidth);
            GPContextTexture.textureContext.lineTo(to.x + toXPenWidth, to.y + toYPenWidth);
            GPContextTexture.textureContext.lineTo(to.x - toXPenWidth, to.y + toYPenWidth);
            GPContextTexture.textureContext.lineTo(from.x - fromXPenWidth, from.y - fromYPenWidth);

            //Following two lines + restore are responsible for offsetting pattern to horizon
            GPContextTexture.textureContext.save();
            if (!GPContextTexture.currentTexture.noHorizonOffset)
                GPContextTexture.textureContext.translate(0, (0.97 - GP.project.horizonPos) * GP.project.sizeY); //TODO

            GPContextTexture.textureContext.stroke();
            GPContextTexture.textureContext.fill();

            GPContextTexture.textureContext.restore();
        } else {
            GPContextTexture.textureContext.beginPath();
            GPContextTexture.textureContext.moveTo(from.x, from.y);

            GPContextTexture.textureContext.lineTo(to.x, to.y);

            //Following two lines + restore are responsible for offsetting pattern to horizon
            GPContextTexture.textureContext.save();
            if (!GPContextTexture.currentTexture.noHorizonOffset)
                GPContextTexture.textureContext.translate(0, (0.97-GP.project.horizonPos)*GP.project.sizeY); //TODO

            GPContextTexture.textureContext.closePath();
            GPContextTexture.textureContext.stroke();

            GPContextTexture.textureContext.restore();
        }

        GPContextTexture.textureLayer.draw();
    },

    calcSquareCursorSize: function(y) {
        let xPenWidth = GPContextTexture.xbrushSizes[GPContextTexture.brushSize];
        return Math.max(0, xPenWidth * (y - (1 - GP.project.horizonPos) * GP.project.sizeY) / GP.project.sizeY);
    },

    moveTextureCursor: function(pos) {
        if (GPContextTexture.brushShape === "optionSquare") {

            let penWidth = 2 * GPContextTexture.calcSquareCursorSize(pos.y / GPProjectView.sceneScale);
            let penHeight = penWidth / GPContextTexture.brushSquareRatio;

            GPContextTexture.textureCursorSquare.setWidth(penWidth * GPProjectView.width / 1024);
            GPContextTexture.textureCursorSquare.setHeight(penHeight * GPProjectView.width / 1024);

            GPContextTexture.textureCursorSquare.setX(pos.x - GPContextTexture.textureCursorSquare.width() / 2);
            GPContextTexture.textureCursorSquare.setY(pos.y - GPContextTexture.textureCursorSquare.height() / 2);
        }
        if (GPContextTexture.brushShape === "optionCircle") {
            GPContextTexture.textureCursorCircle.setX(pos.x);
            GPContextTexture.textureCursorCircle.setY(pos.y);
        }
    },

    moveTextureCursorHandler: function(e) {
        var pos = GPProjectView.getPointerPosition(e);
        GPContextTexture.moveTextureCursor(pos);
    },

    updateTextureCursorMode: function() {
        if (GPContextTexture.brushShape === "optionSquare") {
            if (GPContextTexture.textureContext) GPContextTexture.textureContext.lineWidth = GPContextTexture.brushSquareRounding * GP.project.sizeX / 1024;
        } else {
            let size = GPContextTexture.brushSizes[GPContextTexture.brushSize];
            GPContextTexture.textureCursorCircle.setRadius(size/2 * GPProjectView.width / 1024);
            if (GPContextTexture.textureContext) GPContextTexture.textureContext.lineWidth = GPContextTexture.brushSizes[GPContextTexture.brushSize] * GP.project.sizeX / 1024;
        }
    },

    setupTextureCursor: function() {
        if (!GPContextTexture.textureCursorLastPos)
            GPContextTexture.textureCursorLastPos = {
                x: $('#GPProjectView').innerWidth() / 2,
                y: $('#GPProjectView').innerHeight() * 0.8
            };
        GPContextTexture.updateTextureCursorMode();
        GPContextTexture.textureCursorCircle.setZIndex(1);
        GPContextTexture.textureCursorSquare.setZIndex(1);
        GPContextTexture.moveTextureCursor(GPContextTexture.textureCursorLastPos);
        GPContextTexture.activateCursor();
    },

    disableTextureCursor: function() {
        GPContextTexture.textureCursorCircle.visible(false);
        GPContextTexture.textureCursorSquare.visible(false);
    },

    activateCursor: function() {
        if (GPContextTexture.brushShape === "optionCircle") {
            GPContextTexture.textureCursorCircle.visible(true);
            GPContextTexture.textureCursorSquare.visible(false);
        }
        if (GPContextTexture.brushShape === "optionSquare") {
            GPContextTexture.textureCursorSquare.visible(true);
            GPContextTexture.textureCursorCircle.visible(false);
        }
    },

    handleKeyboard: function (e) {
        //Further actions only when project area active and applying textures
        if (($(".GPProjectView.active").length)) {
            var lastPos = {
                x: GPContextTexture.textureCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextTexture.textureCursorLastPos.y / GPProjectView.sceneScale
            };
            switch (e.which) {
                case 37: // left
                    GPContextTexture.textureCursorLastPos.x -= 5;
                    break;

                case 38: // up
                    GPContextTexture.textureCursorLastPos.y -= 5;
                    break;

                case 39: // right
                    GPContextTexture.textureCursorLastPos.x += 5;
                    break;

                case 40: // down
                    GPContextTexture.textureCursorLastPos.y += 5;
                    break;

                case 27: // esc
                    GP.restoreFocus();
                    break;

                default:
                    return; // exit this handler for other keys

                    e.preventDefault(); // prevent the default action (scroll / move caret)
            }
            var newPos = {
                x: GPContextTexture.textureCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextTexture.textureCursorLastPos.y / GPProjectView.sceneScale
            };
            GPContextTexture.activateCursor();
            GPContextTexture.moveTextureCursor(GPContextTexture.textureCursorLastPos);
            if (e.shiftKey) GPContextTexture.drawTexture(lastPos, newPos);
        }
    }

};

